module.exports = __webpack_public_path__ + "static/media/lava.52888d46.jpeg";